// Salty Spirit — featured luxury partner in Vieques.
// All 7 experiences book via embedded FareHarbor calendars (shortname: saltyspiritllc)
// and live on-site at their own pages (/partner/:slug) + the /luxury landing page.
// gallery / highlights / included are PLACEHOLDER media pending real assets.
const U = (id) =>
  `https://images.unsplash.com/photo-${id}?crop=entropy&cs=srgb&fm=jpg&q=65&w=850`;
const SS = (file) => `https://www.salty-spirit.com/cdn/shop/files/${file}?width=900`;

export const SALTY_SPIRIT = {
  brand: "Salty Spirit",
  location: "Vieques, Puerto Rico",
  cover: SS("Copy_of_GPTempDownload_2.jpg"),
  en: {
    eyebrow: "Luxury Experience · Vieques",
    tagline: "Curated with Salty Spirit",
    title: "Escape the ordinary. Charter Vieques your way.",
    body: "Small groups. Local captains. Private boats, VIP snorkeling and the Guinness-record Bioluminescent Bay — all crafted for travelers who want Vieques at its most personal.",
    cta: "Explore the collection",
  },
  es: {
    eyebrow: "Experiencia de Lujo · Vieques",
    tagline: "Curado con Salty Spirit",
    title: "Escapa lo ordinario. Charter Vieques a tu manera.",
    body: "Grupos pequeños. Capitanes locales. Botes privados, snorkel VIP y la Bahía Bioluminiscente Guinness — todo diseñado para viajeros que quieren Vieques en su versión más íntima.",
    cta: "Explorar la colección",
  },
};

export const saltyExperiences = [
  {
    slug: "bio-bay-clear-kayak",
    itemId: "283526",
    cover: SS("BioBay_1.png"),
    gallery: [SS("BioBay_1.png"), U("1552083375-1447ce886485"), U("1439066615861-d1af74d74000"), U("1559827260-dc66d52bef19")],
    featured: true,
    en: {
      name: "Bio Bay Clear Kayak",
      tag: "Guinness-record bay",
      duration: "~2 hrs (night)",
      short: "Paddle a transparent kayak into the brightest bioluminescent bay on Earth.",
      description: "Glide across Vieques' Mosquito Bay, certified by Guinness World Records as the brightest bioluminescent bay on the planet. Your clear-bottom kayak lets you watch the water glow with every movement — a small-group, once-in-a-lifetime night on the water.",
      highlights: ["Brightest bio bay on Earth", "Clear-bottom kayak", "Guinness-record Mosquito Bay", "Small-group night tour"],
      included: ["Clear kayak & paddle", "Local guide", "Life vest"],
    },
    es: {
      name: "Kayak Transparente Bio Bay",
      tag: "Bahía récord Guinness",
      duration: "~2 hrs (noche)",
      short: "Rema en kayak transparente hasta la bahía bioluminiscente más brillante del mundo.",
      description: "Navega por la Bahía Mosquito de Vieques, certificada por Guinness World Records como la bahía bioluminiscente más brillante del planeta. Tu kayak de fondo transparente te permite ver el agua brillar con cada movimiento — una noche única en la vida.",
      highlights: ["La bahía más brillante del mundo", "Kayak de fondo transparente", "Bahía Mosquito récord Guinness", "Tour nocturno en grupo pequeño"],
      included: ["Kayak transparente y remo", "Guía local", "Chaleco salvavidas"],
    },
  },
  {
    slug: "vip-sunset-bio-bay",
    itemId: "509046",
    cover: SS("VIPBioBay.png"),
    gallery: [SS("VIPBioBay.png"), U("1471922694854-ff1b63b20054"), U("1559827260-dc66d52bef19"), U("1476514525535-07fb3b4ae5f1")],
    featured: true,
    en: {
      name: "VIP Sunset & Bio Bay Charter",
      tag: "Signature experience",
      duration: "~3 hrs (evening)",
      short: "A private boat charter pairing golden-hour cruising with the glowing Bio Bay after dark.",
      description: "Board your private boat for a sunset cruise along the Vieques coast, then linger as night falls over the world-famous Bioluminescent Bay. Local captains, small groups and the island's most magical light show — all to yourselves.",
      highlights: ["Private sunset cruise", "World-famous Bio Bay", "Local captain", "Small private group"],
      included: ["Private boat & captain", "Sunset cruise", "Bio bay experience"],
    },
    es: {
      name: "VIP Atardecer y Bio Bay",
      tag: "Experiencia firma",
      duration: "~3 hrs (tarde)",
      short: "Un charter privado que une el atardecer con la brillante Bahía Bio al anochecer.",
      description: "Aborda tu bote privado para un crucero al atardecer por la costa de Vieques, y quédate mientras cae la noche sobre la famosa Bahía Bioluminiscente. Capitanes locales, grupos pequeños y el espectáculo de luz más mágico de la isla — todo para ustedes.",
      highlights: ["Crucero privado al atardecer", "Bahía Bio famosa", "Capitán local", "Grupo privado pequeño"],
      included: ["Bote privado y capitán", "Crucero al atardecer", "Experiencia bahía bio"],
    },
  },
  {
    slug: "private-snorkeling",
    itemId: "283563",
    cover: SS("SharedSnorkeling.png"),
    gallery: [SS("SharedSnorkeling.png"), U("1583212292454-1fe6229603b7"), U("1682687982501-1e58ab814714"), U("1607153333879-c174d265f1d2")],
    featured: true,
    en: {
      name: "Private Snorkeling",
      tag: "Small group · reef",
      duration: "~3 hrs",
      short: "A private guided snorkel over Vieques' vibrant reefs and turtle grounds.",
      description: "Explore Vieques' clear waters and coral reefs on a private snorkeling charter. With your own captain and gear provided, seek out sea turtles, rays and tropical fish in some of the Caribbean's least-crowded waters.",
      highlights: ["Private charter", "Turtles, rays & reef fish", "Uncrowded waters", "Gear provided"],
      included: ["Private captain & boat", "Snorkel gear", "Bottled water"],
    },
    es: {
      name: "Snorkel Privado",
      tag: "Grupo pequeño · arrecife",
      duration: "~3 hrs",
      short: "Snorkel privado guiado sobre los vibrantes arrecifes de Vieques.",
      description: "Explora las aguas cristalinas y los arrecifes de coral de Vieques en un charter de snorkel privado. Con tu propio capitán y equipo incluido, busca tortugas, rayas y peces tropicales en algunas de las aguas menos concurridas del Caribe.",
      highlights: ["Charter privado", "Tortugas, rayas y peces", "Aguas poco concurridas", "Equipo incluido"],
      included: ["Capitán y bote privados", "Equipo de snorkel", "Agua embotellada"],
    },
  },
  {
    slug: "boat-charter",
    itemId: "283543",
    cover: SS("Boat_Charter_6.png"),
    gallery: [SS("Boat_Charter_6.png"), U("1476514525535-07fb3b4ae5f1"), U("1514282401047-d79a71a590e8"), U("1559128010-7c1ad6e1b6a5")],
    en: {
      name: "Private Boat Charter",
      tag: "Your day, your pace",
      duration: "Half or full day",
      short: "A full private boat day — beaches, snorkel spots and hidden coves, your itinerary.",
      description: "Charter your own boat and captain for the day and explore Vieques on your terms. Secluded beaches, snorkel stops and hidden coves — the flexible way to discover the island's coastline at your own pace.",
      highlights: ["Fully private boat", "Your own itinerary", "Secluded beaches & coves", "Local captain"],
      included: ["Private boat & captain", "Fuel", "Flexible route"],
    },
    es: {
      name: "Charter Privado",
      tag: "Tu día, tu ritmo",
      duration: "Medio día o día completo",
      short: "Un día completo de bote privado — playas, snorkel y calas escondidas a tu ritmo.",
      description: "Alquila tu propio bote y capitán por el día y explora Vieques a tu manera. Playas escondidas, paradas de snorkel y calas secretas — la forma flexible de descubrir la costa de la isla a tu ritmo.",
      highlights: ["Bote totalmente privado", "Tu propio itinerario", "Playas y calas escondidas", "Capitán local"],
      included: ["Bote y capitán privados", "Combustible", "Ruta flexible"],
    },
  },
  {
    slug: "inshore-fishing",
    itemId: "283550",
    cover: SS("InshoreFishing.png"),
    gallery: [SS("InshoreFishing.png"), U("1558618666-fcd25c85cd64"), U("1544551763-77ef2d0cfc6c"), U("1476514525535-07fb3b4ae5f1")],
    en: {
      name: "Inshore Fishing Charter",
      tag: "Reef fishing",
      duration: "Half day",
      short: "Reef and flats fishing in Vieques' calm inshore waters with a local captain.",
      description: "Cast the calm inshore waters and flats around Vieques for tarpon, snapper, jacks and more. Ideal for all experience levels, with gear and expert local guidance included.",
      highlights: ["Calm inshore & flats", "Tarpon, snapper & jacks", "All experience levels", "Local expert captain"],
      included: ["Rods, reels & tackle", "Bait", "Captain & mate"],
    },
    es: {
      name: "Pesca Costera",
      tag: "Pesca de arrecife",
      duration: "Medio día",
      short: "Pesca en arrecife y bajos en las aguas calmadas de Vieques con capitán local.",
      description: "Pesca en las aguas calmadas y bajos alrededor de Vieques buscando sábalo, pargo, jureles y más. Ideal para todos los niveles, con equipo y guía local experto incluidos.",
      highlights: ["Aguas costeras calmadas", "Sábalo, pargo y jureles", "Todos los niveles", "Capitán experto local"],
      included: ["Cañas, carretes y aparejos", "Carnada", "Capitán y ayudante"],
    },
  },
  {
    slug: "offshore-fishing",
    itemId: "473669",
    cover: SS("OffshoreFishing_1.png"),
    gallery: [SS("OffshoreFishing_1.png"), U("1518877593221-1f28583780b4"), U("1544551763-77ef2d0cfc6c"), U("1559827260-dc66d52bef19")],
    en: {
      name: "Offshore Fishing Charter",
      tag: "Mahi · wahoo · marlin",
      duration: "Full day",
      short: "Head to blue water for mahi, wahoo, tuna and marlin off Vieques.",
      description: "Run offshore into the deep blue for big-game sport fishing — mahi-mahi, wahoo, tuna and marlin. A serious charter for anglers chasing the catch of a lifetime off Vieques.",
      highlights: ["Deep-blue big-game fishing", "Mahi, wahoo, tuna & marlin", "Serious sport charter", "Experienced crew"],
      included: ["Offshore boat & crew", "Rods & tackle", "Fuel"],
    },
    es: {
      name: "Pesca Mar Adentro",
      tag: "Mahi · wahoo · marlin",
      duration: "Día completo",
      short: "Sal a mar abierto por mahi, wahoo, atún y marlin frente a Vieques.",
      description: "Navega mar adentro al azul profundo para pesca deportiva mayor — mahi-mahi, wahoo, atún y marlin. Un charter serio para pescadores que buscan la captura de su vida frente a Vieques.",
      highlights: ["Pesca mayor en mar abierto", "Mahi, wahoo, atún y marlin", "Charter deportivo serio", "Tripulación experimentada"],
      included: ["Bote y tripulación", "Cañas y aparejos", "Combustible"],
    },
  },
  {
    slug: "culebra-charter",
    itemId: "621738",
    cover: U("1468413253725-0d5181091126"),
    gallery: [U("1468413253725-0d5181091126"), U("1559128010-7c1ad6e1b6a5"), U("1514282401047-d79a71a590e8"), U("1507525428034-b723cf961d3e")],
    en: {
      name: "Culebra Day Charter",
      tag: "Flamenco Beach",
      duration: "Full day",
      short: "A private boat day to Culebra's Flamenco Beach — one of the world's best.",
      description: "Cruise from Vieques to Culebra for a day at Flamenco Beach, consistently ranked among the most beautiful beaches on Earth. Swim, snorkel and relax on powder-white sand on this private full-day charter.",
      highlights: ["Day trip to Culebra", "World-famous Flamenco Beach", "Swim & snorkel stops", "Private boat"],
      included: ["Private boat & captain", "Snorkel gear", "Beach time"],
    },
    es: {
      name: "Charter a Culebra",
      tag: "Playa Flamenco",
      duration: "Día completo",
      short: "Un día en bote privado a Playa Flamenco de Culebra — de las mejores del mundo.",
      description: "Navega de Vieques a Culebra para un día en Playa Flamenco, siempre entre las playas más hermosas del planeta. Nada, haz snorkel y relájate en arena blanca en este charter privado de día completo.",
      highlights: ["Excursión a Culebra", "Famosa Playa Flamenco", "Paradas para nadar y snorkel", "Bote privado"],
      included: ["Bote y capitán privados", "Equipo de snorkel", "Tiempo en la playa"],
    },
  },
];
